"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _excluded = ["children", "icon", "active", "disabled", "clickable", "selectable", "deletable", "revertable", "multiline", "muted", "round"];
var Tag = function Tag(props) {
  var children = props.children,
    icon = props.icon,
    active = props.active,
    disabled = props.disabled,
    clickable = props.clickable,
    selectable = props.selectable,
    deletable = props.deletable,
    revertable = props.revertable,
    multiline = props.multiline,
    muted = props.muted,
    round = props.round,
    remainingProps = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, remainingProps, {
    className: (0, _classnames["default"])('tag', props.size === 'small' && 'tag-small', icon && "rioglyph ".concat(icon), active && 'active clickable rioglyph rioglyph-ok', disabled && 'disabled', clickable && 'clickable', selectable && 'selectable clickable rioglyph rioglyph-checkbox', deletable && 'deletable clickable rioglyph rioglyph-remove', revertable && 'revertable clickable rioglyph rioglyph-revert', multiline && 'multiline', muted && 'tag-muted', !round && 'rounded',
    // sounds wrong, but is right
    props.className)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tag-inner"
  }, children));
};
Tag.defaultProps = {
  active: false,
  clickable: false,
  deletable: false,
  revertable: false,
  disabled: false,
  muted: false,
  round: true,
  selectable: false
};
Tag.propTypes = {
  active: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  clickable: _propTypes["default"].bool,
  deletable: _propTypes["default"].bool,
  revertable: _propTypes["default"].bool,
  disabled: _propTypes["default"].bool,
  icon: _propTypes["default"].string,
  muted: _propTypes["default"].bool,
  multiline: _propTypes["default"].bool,
  round: _propTypes["default"].bool,
  selectable: _propTypes["default"].bool,
  size: _propTypes["default"].oneOf(['small'])
};
var _default = Tag;
exports["default"] = _default;